import PhoneNumber from './components/index';

export default PhoneNumber;
